module.exports = __webpack_public_path__ + "img/23895de.png";